module.exports = __webpack_public_path__ + "img/book.5faba19d.svg";